import localforage from 'localforage'
import $ from 'jquery'

// Getting and setting db values must be atomic! LocalForage doesn't care: https://github.com/localForage/localForage/issues/17
// Fixes scenario: 1. Type in a custom item volume. 2. Tap count^ button. On Safari/iPad and Firefox/Android, this often lost the volume change.
var synchd = require('synchd')
var localforageScope = {localforageScope}

var localforageStoreItems = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'items'
})

const initialState = {
  all: [],
  item: {
    itemId: null,
    roomId: null,
    surveyId: null,
    itemName: null,
    itemNameId: null,
    volume: 0,
    weight: 0,
    count: 1,
    mode: 'FCL',
    disassembly: false,
    disassembly3rd: false,
    assembly: false,
    assembly3rd: false,
    packing: '',
    packedByOwner: false,
    crateType: null,
    crateL: null,
    crateW: null,
    crateH: null,
    comments: null
  }
}

let state = initialState

const getters = {
  getAllItems: state => state.all,
  getItem: state => state.item
}

const actions = {
  loadAllItems ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let items = []
      localforageStoreItems.getItems().then((results) => {
        if (results) {
          for (let result in results) {
            items.push(JSON.parse(results[result]))
          }
        }
        commit('receiveItems', items)
        resolve(items)
      })
    })
  },
  loadItems ({ commit }, identifier) {
    return new Promise((resolve, reject) => {
      let items = []
      localforageStoreItems.startsWith(identifier).then(function (results) {
        if (results) {
          $.each(results, function (index, value) {
            items.push(JSON.parse(value))
          })
          commit('receiveItems', items)
          resolve()
        }
      }).catch(function (err) {
        console.log(err)
      })
    })
  },
  loadItemsForSurvey ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      let key = 'survey-' + surveyId
      let items = []
      localforageStoreItems.startsWith(key).then((results) => {
        if (results) {
          $.each(results, (index, value) => {
            items.push(JSON.parse(value))
          })
        }
        commit('receiveItems', items)
        resolve()
      })
    })
  },
  loadItem ({ commit }, identifier) {
    return new Promise((resolve, reject) => {
      localforageStoreItems.getItem(identifier).then((result) => {
        commit('receiveItem', JSON.parse(result))
        resolve()
      })
    })
  },
  addItem ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      localforageStoreItems.setItem(payload.storageKey, JSON.stringify(payload.item)).then(function () {
        commit('addItemFromStorage', payload.item)
        resolve()
      })
    })
  },
  updateItem ({ commit }, {storageKey, item}) {
    return new Promise((resolve, reject) => {
      localforageStoreItems.setItem(storageKey, JSON.stringify(item)).then(() => {
        commit('receiveUpdatedItem', item)
        resolve()
      })
    })
  },
  updateItemCount ({ commit }, payload) {
    return synchd.synchd(localforageScope, () =>
      new Promise((resolve, reject) => {
        localforageStoreItems.getItem(String(payload.storageKey)).then(function (item) {
          item = JSON.parse(item)
          item.count = payload.count
          localforageStoreItems.setItem(payload.storageKey, JSON.stringify(item)).then(function (value) {
            commit('setUpdatedItemCount', { payload: payload, item: item })
            resolve()
          })
        })
      })
    )
  },
  updateItemVolume ({ commit }, payload) {
    return synchd.synchd(localforageScope, () =>
      new Promise((resolve, reject) => {
        localforageStoreItems.getItem(String(payload.storageKey)).then(function (item) {
          item = JSON.parse(item)
          item.volume = payload.volume
          localforageStoreItems.setItem(payload.storageKey, JSON.stringify(item)).then(function (value) {
            commit('setUpdatedItemVolume', { payload: payload, item: item })
            resolve()
          })
        })
      })
    )
  },
  updateItemWeight ({ commit }, payload) {
    return synchd.synchd(localforageScope, () =>
      new Promise((resolve, reject) => {
        localforageStoreItems.getItem(String(payload.storageKey)).then(function (item) {
          item = JSON.parse(item)
          item.weight = payload.weight
          localforageStoreItems.setItem(payload.storageKey, JSON.stringify(item)).then(function (value) {
            commit('setUpdatedItemWeight', { payload: payload, item: item })
            resolve()
          })
        })
      })
    )
  },
  updateItemMode ({ commit }, payload) {
    return synchd.synchd(localforageScope, () =>
      new Promise((resolve, reject) => {
        localforageStoreItems.getItem(String(payload.storageKey)).then(function (item) {
          item = JSON.parse(item)
          item.mode = payload.mode
          localforageStoreItems.setItem(payload.storageKey, JSON.stringify(item)).then(function (value) {
            commit('setUpdatedItemMode', { payload: payload, item: item })
            resolve()
          })
        })
      })
    )
  },
  deleteItem ({ commit }, itemStorageKey) {
    return new Promise((resolve, reject) => {
      localforageStoreItems.removeItem(String(itemStorageKey)).then(() => {
        commit('removeItemFormState')
        resolve()
      })
    })
  },
  deleteSurveyItems ({ commit, state }, surveyId) {
    return new Promise((resolve, reject) => {
      // get localforage keys of all objs to be deleted
      let keys = []
      localforageStoreItems.iterate((result, key) => {
        result = JSON.parse(result)
        if (result.surveyId === surveyId) {
          keys.push({
            'key': key,
            'id': result.id
          })
        }
      },
      () => {
        // success callback: delete all objs from localforage, resolve once all keys have been processed
        let counter = 0
        keys.forEach((result) => {
          localforageStoreItems.removeItem(String(result.key)).then(() => {
            commit('removeItemFormIndexState', result.id)
            counter++
            if (counter === keys.length) {
              resolve()
            }
          })
        })
        if (counter === 0) {
          resolve()
        }
      })
    })
  },
  importItems ({ commit }, items) {
    return new Promise((resolve, reject) => {
      commit('clearItemsState')
      items.forEach((item) => {
        const key = 'survey-' + item.surveyId + '-room-' + item.roomId + '-item-' + item.itemId
        localforageStoreItems.setItem(key, JSON.stringify(item)).then(() => {
          commit('receiveItem', item)
        })
      })
      resolve()
    })
  },
  clearItemsStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreItems.clear().then(() => {
        commit('clearItemsState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  receiveItems (state, items) {
    state.all = items
  },
  receiveItem (state, item) {
    state.item = item
  },
  addItemFromStorage (state, payload) {
    state.all.push(payload)
  },
  receiveUpdatedItem (state, item) {
    let index = state.all.findIndex(x => x.itemId === item.itemId)
    state.all[index] = item
  },
  setUpdatedItemName (state, { payload, item }) {
    let index = state.all.findIndex(x => x.itemId === item.itemId)
    state.all[index] = item
  },
  setUpdatedItemCount (state, { payload, item }) {
    let index = state.all.findIndex(x => x.itemId === item.itemId)
    state.all[index] = item
  },
  setUpdatedItemVolume (state, { payload, item }) {
    let index = state.all.findIndex(x => x.itemId === item.itemId)
    state.all[index] = item
  },
  setUpdatedItemWeight (state, { payload, item }) {
    let index = state.all.findIndex(x => x.itemId === item.itemId)
    state.all[index] = item
  },
  setUpdatedItemMode (state, { payload, item }) {
    let index = state.all.findIndex(x => x.itemId === item.itemId)
    state.all[index] = item
  },
  removeItemFormState (state) {
    state.item = null
  },
  removeItemFormIndexState (state, itemId) {
    let index = state.all.findIndex(x => x.id === itemId)
    state.all.splice(index, 1)
  },
  clearItemsState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/items.js